import React, { useEffect, useState, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  call,
  copy,
  gpay,
  others,
  paytm,
  phonepay,
  QR,
} from "../../assets/img";

import { ICON_FILTER, URLS } from "../../Services/Constant";
import { deletes, get, post } from "../../Services/ApiHandler";

import Loader from "../../Component/Loader";
import { Toast } from "../../Component/Toast";
import Cropper from "cropperjs";

// Import the CSS file directly from cropperjs
import "cropperjs/dist/cropper.css";
import useStoreKv from "../redux/store/useStorekv";
import CustomScroll from "../../Component/CustomScroll";
import SubmitButton from "../../Component/SubmitButton";
import CommonPopup from "../../Component/CommonPopup";
import { MaskIcon } from "../../Component/MaskIcon";
import { PRIMARY_COLOR } from "../../Services/Colors";
// OR if that doesn't work, use:
// import "cropperjs/src/css/cropper.css";

// If both above don't work, add this CSS inline or in your own CSS file:
const cropperStyles = `
  .cropper-container {
    direction: ltr;
    font-size: 0;
    line-height: 0;
    position: relative;
    touch-action: none;
    user-select: none;
  }

  .cropper-container img {
    display: block;
    height: 100%;
    image-orientation: 0deg;
    max-height: none !important;
    max-width: none !important;
    min-height: 0 !important;
    min-width: 0 !important;
    width: 100%;
  }

  .cropper-wrap-box,
  .cropper-canvas,
  .cropper-drag-box,
  .cropper-crop-box,
  .cropper-modal {
    bottom: 0;
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
  }

  .cropper-wrap-box,
  .cropper-canvas {
    overflow: hidden;
  }

  .cropper-drag-box {
    background-color: #fff;
    opacity: 0;
  }

  .cropper-modal {
    background-color: #000;
    opacity: 0.5;
  }

  .cropper-view-box {
    display: block;
    height: 100%;
    outline: 1px solid #39f;
    outline-color: rgba(51, 153, 255, 0.75);
    overflow: hidden;
    width: 100%;
  }

  .cropper-dashed {
    border: 0 dashed #eee;
    display: block;
    opacity: 0.5;
    position: absolute;
  }

  .cropper-dashed.dashed-h {
    border-bottom-width: 1px;
    border-top-width: 1px;
    height: calc(100% / 3);
    left: 0;
    top: calc(100% / 3);
    width: 100%;
  }

  .cropper-dashed.dashed-v {
    border-left-width: 1px;
    border-right-width: 1px;
    height: 100%;
    left: calc(100% / 3);
    top: 0;
    width: calc(100% / 3);
  }

  .cropper-center {
    display: block;
    height: 0;
    left: 50%;
    opacity: 0.75;
    position: absolute;
    top: 50%;
    width: 0;
  }

  .cropper-center:before,
  .cropper-center:after {
    background-color: #eee;
    content: ' ';
    display: block;
    position: absolute;
  }

  .cropper-center:before {
    height: 1px;
    left: -3px;
    top: 0;
    width: 7px;
  }

  .cropper-center:after {
    height: 7px;
    left: 0;
    top: -3px;
    width: 1px;
  }

  .cropper-face,
  .cropper-line,
  .cropper-point {
    display: block;
    height: 100%;
    opacity: 0.1;
    position: absolute;
    width: 100%;
  }

  .cropper-face {
    background-color: #fff;
    left: 0;
    top: 0;
  }

  .cropper-line {
    background-color: #39f;
  }

  .cropper-line.line-e {
    cursor: ew-resize;
    right: -3px;
    top: 0;
    width: 5px;
  }

  .cropper-line.line-n {
    cursor: ns-resize;
    height: 5px;
    left: 0;
    top: -3px;
  }

  .cropper-line.line-w {
    cursor: ew-resize;
    left: -3px;
    top: 0;
    width: 5px;
  }

  .cropper-line.line-s {
    bottom: -3px;
    cursor: ns-resize;
    height: 5px;
    left: 0;
  }

  .cropper-point {
    background-color: #39f;
    height: 5px;
    opacity: 0.75;
    width: 5px;
  }

  .cropper-point.point-e {
    cursor: ew-resize;
    margin-top: -3px;
    right: -3px;
    top: 50%;
  }

  .cropper-point.point-n {
    cursor: ns-resize;
    left: 50%;
    margin-left: -3px;
    top: -3px;
  }

  .cropper-point.point-w {
    cursor: ew-resize;
    left: -3px;
    margin-top: -3px;
    top: 50%;
  }

  .cropper-point.point-s {
    bottom: -3px;
    cursor: ns-resize;
    left: 50%;
    margin-left: -3px;
  }

  .cropper-point.point-ne {
    cursor: nesw-resize;
    right: -3px;
    top: -3px;
  }

  .cropper-point.point-nw {
    cursor: nwse-resize;
    left: -3px;
    top: -3px;
  }

  .cropper-point.point-sw {
    bottom: -3px;
    cursor: nesw-resize;
    left: -3px;
  }

  .cropper-point.point-se {
    bottom: -3px;
    cursor: nwse-resize;
    right: -3px;
    height: 20px;
    opacity: 1;
    width: 20px;
  }

  @media (min-width: 768px) {
    .cropper-point.point-se {
      height: 15px;
      width: 15px;
    }
  }

  @media (min-width: 992px) {
    .cropper-point.point-se {
      height: 10px;
      width: 10px;
    }
  }

  @media (min-width: 1200px) {
    .cropper-point.point-se {
      height: 5px;
      opacity: 0.75;
      width: 5px;
    }
  }

  .cropper-point.point-se:before {
    background-color: #39f;
    bottom: -50%;
    content: ' ';
    display: block;
    height: 200%;
    opacity: 0;
    position: absolute;
    right: -50%;
    width: 200%;
  }

  .cropper-invisible {
    opacity: 0;
  }

  .cropper-bg {
    background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQAQMAAAAlPW0iAAAAA3NCSVQICAjb4U/gAAAABlBMVEXMzMz////TjRV2AAAACXBIWXMAAArrAAAK6wGCiw1aAAAAHHRFWHRTb2Z0d2FyZQBBZG9iZSBGaXJld29ya3MgQ1M26LyyjAAAABFJREFUCJlj+M/AgBVhF/0PAH6/D/HkDxOGAAAAAElFTkSuQmCC');
  }

  .cropper-hide {
    display: block;
    height: 0;
    position: absolute;
    width: 0;
  }

  .cropper-hidden {
    display: none !important;
  }

  .cropper-move {
    cursor: move;
  }

  .cropper-crop {
    cursor: crosshair;
  }

  .cropper-disabled .cropper-drag-box,
  .cropper-disabled .cropper-face,
  .cropper-disabled .cropper-line,
  .cropper-disabled .cropper-point {
    cursor: not-allowed;
  }
`;

const AdminRecharge = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const { kv, set } = useStoreKv();
  const adminRechargeUpi = kv.adminrechargeupi || [];
  const adminRechargeQr1 = kv.adminrechargeqr1 || [];
  const adminRechargeQr2 = kv.adminrechargeqr2 || [];

  const [errors, setErrors] = useState({});
  const [mobile, setMobile] = useState("");
  const [popup, setPopup] = useState(false);
  const [selectedPay, setSelectedPay] = useState("gpay");
  const [qrImages, setQrImages] = useState(adminRechargeQr1 ?? QR);
  const [qrImages2, setQrImages2] = useState(adminRechargeQr2 ?? QR);
  const [loading, setLoading] = useState(false);
  const [loading1, setLoading1] = useState(false);
  const [updating, setUpdating] = useState(false);
  const [updating2, setUpdating2] = useState(false);
  const [updating3, setUpdating3] = useState(false);
  const [deleting, setDeleting] = useState(false);
  const [deleting2, setDeleting2] = useState(false);
  const [deleting3, setDeleting3] = useState(false);
  const [check, setCheck] = useState(false);
  const [check2, setCheck2] = useState(false);
  const [check3, setCheck3] = useState(false);
  const [confirmAction, setConfirmAction] = useState('');
  const [popupMessage, setPopupMessage] = useState('');

  // Cropper.js states
  const [cropperModal, setCropperModal] = useState(false);
  const [cropperImage, setCropperImage] = useState(null);
  const [cropperInstance, setCropperInstance] = useState(null);
  const [croppingFor, setCroppingFor] = useState(null); // 'qr1' or 'qr2'

  const cropperImageRef = useRef(null);
  const fileInputRef1 = useRef(null);
  const fileInputRef2 = useRef(null);

  const [formData, setFormData] = useState(
    adminRechargeUpi ?? {
      empty: "",
      transactionId: "",
      copyUpi: "",
    });

  // Add cropper styles to document
  useEffect(() => {
    const styleElement = document.createElement('style');
    styleElement.innerHTML = cropperStyles;
    document.head.appendChild(styleElement);

    return () => {
      document.head.removeChild(styleElement);
    };
  }, []);

  // ✅ handle input change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  // ✅ handle QR upload - Now opens cropper
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      // Check file size (limit to 5MB)
      if (file.size > 5 * 1024 * 1024) {
        Toast("File size should be less than 5MB");
        return;
      }

      // Check file type
      if (!file.type.match('image.*')) {
        Toast("Please select an image file");
        return;
      }

      const reader = new FileReader();
      reader.onload = (event) => {
        setCropperImage(event.target.result);
        setCroppingFor('qr1');
        setCropperModal(true);
      };
      reader.onerror = () => {
        Toast("Error reading file");
      };
      reader.readAsDataURL(file);
    }
  };

  const handleFileChange2 = (e) => {
    const file = e.target.files[0];
    if (file) {
      // Check file size (limit to 5MB)
      if (file.size > 5 * 1024 * 1024) {
        Toast("File size should be less than 5MB");
        return;
      }

      // Check file type
      if (!file.type.match('image.*')) {
        Toast("Please select an image file");
        return;
      }

      const reader = new FileReader();
      reader.onload = (event) => {
        setCropperImage(event.target.result);
        setCroppingFor('qr2');
        setCropperModal(true);
      };
      reader.onerror = () => {
        Toast("Error reading file");
      };
      reader.readAsDataURL(file);
    }
  };

  // ✅ Initialize cropper when image loads
  useEffect(() => {
    if (cropperModal && cropperImageRef.current && cropperImage) {
      if (cropperInstance) {
        cropperInstance.destroy();
      }

      const cropper = new Cropper(cropperImageRef.current, {
        aspectRatio: 1, // Square aspect ratio for QR codes
        viewMode: 1,
        autoCropArea: 1,
        responsive: true,
        restore: true,
        guides: true,
        center: true,
        highlight: true,
        cropBoxMovable: true,
        cropBoxResizable: true,
        toggleDragModeOnDblclick: true,
        minCropBoxWidth: 100,
        minCropBoxHeight: 100,
        ready: function () {
          //           console.log("Cropper initialized");
        },
      });

      setCropperInstance(cropper);
    }

    return () => {
      if (cropperInstance) {
        cropperInstance.destroy();
        setCropperInstance(null);
      }
    };
  }, [cropperModal, cropperImage]);

  // ✅ Crop and save image
  const handleCrop = () => {
    if (cropperInstance) {
      const croppedCanvas = cropperInstance.getCroppedCanvas({
        width: 300,
        height: 300,
        fillColor: '#fff',
        imageSmoothingEnabled: true,
        imageSmoothingQuality: 'high'
      });

      if (croppedCanvas) {
        croppedCanvas.toBlob((blob) => {
          if (blob) {
            const fileName = `qr_${Date.now()}.png`;
            const file = new File([blob], fileName, { type: 'image/png' });

            if (croppingFor === 'qr1') {
              setQrImages(file);
              setCheck(true);
            } else if (croppingFor === 'qr2') {
              setQrImages2(file);
              setCheck3(true);
            }

            setCropperModal(false);
            setCropperImage(null);
            setCroppingFor(null);

            if (cropperInstance) {
              cropperInstance.destroy();
              setCropperInstance(null);
            }

            Toast("Image cropped successfully!");
          }
        }, 'image/png', 0.95);
      }
    }
  };

  // ✅ Cancel cropping
  const handleCancelCrop = () => {
    setCropperModal(false);
    setCropperImage(null);
    setCroppingFor(null);

    if (cropperInstance) {
      cropperInstance.destroy();
      setCropperInstance(null);
    }

    // Reset file inputs
    if (fileInputRef1.current) fileInputRef1.current.value = '';
    if (fileInputRef2.current) fileInputRef2.current.value = '';

    Toast("Cropping cancelled");
  };

  // ✅ validate recharge form
  const validate = () => {
    let newErrors = {};

    if (!mobile) {
      newErrors.mobile = "Mobile number is required";
    } else if (!/^[0-9]{10}$/.test(mobile)) {
      newErrors.mobile = "Enter a valid 10-digit mobile number";
    }

    if (!formData.empty) {
      newErrors.empty = "Amount is required";
    } else if (Number(formData.empty) <= 0) {
      newErrors.empty = "Enter a valid amount";
    }

    if (!formData.transactionId) {
      newErrors.transactionId = "Transaction ID is required";
    } else if (formData.transactionId.length < 6) {
      newErrors.transactionId = "Transaction ID must be at least 6 characters";
    }

    if (!selectedPay) {
      newErrors.selectedPay = "Please select a payment method";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // ✅ confirm recharge
  const handleBankRecharge = async () => {
    if (!validate()) return;

    const posts = {
      mobile: mobile,
      amount: formData.empty,
      method: selectedPay,
      transaction_id: formData.transactionId,
    };

    try {
      setLoading1(true);
      const res = await post(`${URLS.ADMINRECHARGEBANK}`, posts);
      if (res?.status === "success") {
        Toast("Recharge successful!");
        setFormData({ empty: "", transactionId: "", copyUpi: formData.copyUpi });
        setMobile("");
        setSelectedPay("");
      }
    } catch (err) {
      console.error("Error fetching:", err);
    } finally {
      setLoading1(false);
    }
  };

  // ✅ fetch existing UPI & QR
  const getList = async () => {
    try {
      if (!kv.adminrechargeupi || kv.adminrechargeupi.length === 0) {
        setLoading(true);
      }
      const resUpi = await get(`${URLS.MASTER}?type=2`);
      if (resUpi?.status === "success" && resUpi?.data) {
        setFormData((prev) => ({
          ...prev,
          copyUpi: resUpi?.data?.upi_id || "",
        }));
        set('adminrechargeupi', {
          copyUpi: resUpi?.data?.upi_id || "",
        })
      } else {
        setFormData((prev) => ({
          ...prev,
          copyUpi: "",
        }));
        set('adminrechargeupi', {
          copyUpi: "",
        });
      }

      const resQR = await get(`${URLS.MASTER}?type=1`);
      if (resQR?.status === "success" && resQR?.data) {
        setQrImages(resQR?.data?.image || null);
        setQrImages2(resQR?.data?.image_two || null);
        set('adminrechargeqr1', resQR?.data?.image || null);
        set('adminrechargeqr2', resQR?.data?.image_two || null);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getList();
  }, []);

  // ✅ copy UPI ID
  const handleCopy = () => {
    if (!formData.copyUpi) {
      Toast("No UPI ID to copy");
      return;
    }
    navigator.clipboard.writeText(formData.copyUpi);
    Toast("UPI ID copied to clipboard!");
  };

  // ✅ Update QR only
  const handleUpdateQR = async () => {
    try {
      setUpdating(true);
      const form = new FormData();
      if (qrImages instanceof File) {
        form.append("image", qrImages);
        form.append('id', 1)
      }
      const res = await post(`${URLS.ADMIN_UPDATE_QR}`, form);
      if (res?.status === "success") {
        Toast("QR Code updated successfully!");
        setCheck(false);
        getList();
      }
    } catch (err) {
      console.error("QR Update Error:", err);
    } finally {
      setUpdating(false);
    }
  };

  const handleUpdateQR2 = async () => {
    try {
      setUpdating3(true);
      const form = new FormData();
      if (qrImages2 instanceof File) {
        form.append("image_two", qrImages2);
        form.append('id', 1)
      }
      const res = await post(`${URLS.ADMIN_UPDATE_QR}`, form);
      if (res?.status === "success") {
        Toast("QR Code updated successfully!");
        setCheck3(false);
        getList();
      }
    } catch (err) {
      console.error("QR Update Error:", err);
    } finally {
      setUpdating3(false);
    }
  };

  // ✅ Delete QR
  const handleDeleteQR = async () => {
    try {
      setDeleting(true);
      const res = await post(`${URLS.ADMIN_DELETE_QR}/${1}`, { type: "image" });
      if (res?.status === "success") {
        Toast("QR Code deleted successfully!");
        setQrImages(null);
      }
    } catch (err) {
      console.error("Delete QR Error:", err);
    } finally {
      setDeleting(false);
    }
  };

  const handleDeleteQR2 = async () => {
    try {
      setDeleting3(true);
      const res = await post(`${URLS.ADMIN_DELETE_QR}/${1}`, { type: "image_two" });
      if (res?.status === "success") {
        Toast("QR Code deleted successfully!");
        setQrImages2(null);
      }
    } catch (err) {
      console.error("Delete QR Error:", err);
    } finally {
      setDeleting3(false);
    }
  };

  // ✅ Update UPI only
  const handleUpdateUPI = async () => {
    try {
      setUpdating2(true);
      const res = await post(`${URLS.ADMIN_UPDATE_UPI}`, { id: 2, upi_id: formData.copyUpi });
      if (res?.status === "success") {
        Toast("UPI ID updated successfully!");
        setCheck2(false);
        getList();
      }
    } catch (err) {
      console.error("UPI Update Error:", err);
    } finally {
      setUpdating2(false);
    }
  };

  // ✅ Delete UPI
  const handleDeleteUPI = async () => {
    try {
      setDeleting2(true);
      const res = await deletes(`${URLS.ADMIN_DELETE_UPI}/${2}`);
      if (res?.status === "success") {
        Toast("UPI ID deleted successfully!");
        setFormData((prev) => ({ ...prev, copyUpi: "" }));
      }
    } catch (err) {
      console.error("Delete UPI Error:", err);
    } finally {
      setDeleting2(false);
    }
  };

  // ✅ Handle confirmation
  const handleConfirm = () => {
    if (confirmAction === 'recharge') {
      handleBankRecharge();
    } else if (confirmAction === 'updateQR') {
      handleUpdateQR();
    } else if (confirmAction === 'deleteQR') {
      handleDeleteQR();
    } else if (confirmAction === 'updateQR2') {
      handleUpdateQR2();
    } else if (confirmAction === 'deleteQR2') {
      handleDeleteQR2();
    } else if (confirmAction === 'updateUPI') {
      handleUpdateUPI();
    } else if (confirmAction === 'deleteUPI') {
      handleDeleteUPI();
    }
    setPopup(false);
    setConfirmAction('');
    setPopupMessage('');
  };

  return (
    <div className="dashRightView ">
      <CustomScroll >
        <div style={{ paddingTop: 0, paddingBottom: 80 }} className="container_overalls col-md-5">
          {/* ===== Recharge Form Section ===== */}
          <div className="form-group text-start my-3 col-md-5">
            <label className="form-label f3 fs-md-14 fs-lg-16 m-0 primary1">
              Mobile Number</label>
            <div className="login-input3 mt-1">
              <input
                value={mobile}
                onChange={(e) => {
                  const value = e.target.value.replace(/\D/g, "");
                  if (value.length <= 10) setMobile(value);
                }}
                className="placholdercolorchanges2"
                type="tel"
                placeholder="Enter Mobile Number"
                maxLength={10}
              />
              <MaskIcon src={call} alt="call icon" style={{ marginRight: 12, width: 20, top: 1, position: 'relative' }} />
            </div>
            {errors.mobile && <p className="err">{errors.mobile}</p>}
          </div>

          <div className="form-group text-start my-3 col-md-5">
            <label className="form-label f3 fs-md-14 fs-lg-16 m-0 primary1">
              Amount</label>
            <div className="login-input3 mt-1">
              <input
                name="empty"
                value={formData.empty}
                onChange={handleChange}
                onInput={(e) => {
                  if (e.target.value.length > 11) {
                    e.target.value = e.target.value.slice(0, 11);
                  }
                }}
                type="number"
                placeholder="Enter Amount"
                className="placholdercolorchanges2"
              />
              <p style={{ fontSize: 18, fontFamily: 'f3' ,color:PRIMARY_COLOR}}>₹</p>
            </div>
            {errors.empty && <p className="err">{errors.empty}</p>}
          </div>

          <div className="my-3 col-md-5">
            <label className="form-label f3 fs-md-14 fs-lg-16 m-0 primary1">
              {selectedPay === "phonepe" ? "UTR Number" : "Transaction ID"}</label>
            <input
              className="input-box placholdercolorchanges2"
              name="transactionId"
              value={formData.transactionId}
              onChange={(e) => {
                const value = e.target.value;
                if (/^\d{0,14}$/.test(value)) {
                  handleChange(e);
                }
              }}
              type="number"
              maxLength={14}
              placeholder={
                selectedPay === "phonepe"
                  ? "Enter UTR Number"
                  : "Enter Transaction ID"
              }
            />
            {errors.transactionId && <p className="err">{errors.transactionId}</p>}
          </div>

          <div className="py-3 col-md-5 d-flex ac-js gap-3">
            <div className="payment1">
              <img
                src={gpay}
                alt="GPay"
                className={`gpay ${selectedPay === "gpay" ? "selected-pay" : ""}`}
                onClick={() => setSelectedPay("gpay")}
              />
              <img
                src={phonepay}
                alt="phonepe"
                className={`phonepay ${selectedPay === "phonepe" ? "selected-pay-phonepay" : ""}`}
                onClick={() => setSelectedPay("phonepe")}
              />
              <img
                src={paytm}
                alt="Paytm"
                className={`patym ${selectedPay === "paytm" ? "selected-pay" : ""}`}
                onClick={() => setSelectedPay("paytm")}
              />
              <img
                src={others}
                alt="other"
                className={`patym ${selectedPay === "other" ? "selected-pay" : ""}`}
                onClick={() => setSelectedPay("other")}
              />
            </div>
          </div>
          {errors.selectedPay && <p className="err">{errors.selectedPay}</p>}

          <div className="my-3">
            {/* <button
              onClick={() => { setConfirmAction('recharge'); setPopupMessage('Are you sure you want to confirm the recharge?'); setPopup(true); }}
              className="add-button f3  fs-xs-16 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19 sec"
              disabled={loading}
              style={{ minWidth: "42%" }}
            >
              {loading1 ? <>
                <span
                  className="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                  style={{ color: "black" }}
                ></span>
              </> : "Confirm Recharge"}
            </button> */}
            <SubmitButton
              onClick={() => { setConfirmAction('recharge'); setPopupMessage('Are you sure you want to confirm the recharge?'); setPopup(true); }}
              disabled={loading1}
              title="Confirm Recharge"
              width="42%"
            />
          </div>

          {/* ===== QR Section ===== */}
          <div className="mt-5 textChanges QRCode_container col-md-5">
            <input
              id="qrCodeUpload"
              ref={fileInputRef1}
              type="file"
              accept="image/*"
              style={{ display: "none" }}
              onChange={handleFileChange}
              className="placholdercolorchanges2"
            />

            <label style={{ position: "relative" }} htmlFor="qrCodeUpload" className="mt-2 QRcode sec">
              {qrImages ? (
                <img
                  src={
                    qrImages instanceof File
                      ? URL.createObjectURL(qrImages)
                      : qrImages
                  }
                  alt="QR Preview"
                  style={{
                    width: "150px",
                    height: "150px",
                    borderRadius: "10px",
                    objectFit: "contain",
                  }}
                />
              ) : (
                <>
                  <img
                    src={QR}
                    alt="QR Placeholder"
                    style={{
                      width: "150px",
                      height: "150px",
                      borderRadius: "10px",
                      objectFit: "contain",
                      border: "1.8px dashed #a7a3a3"
                    }}
                  />
                  <span
                    style={{
                      position: "absolute",
                      right: 40,
                      top: 50,
                      color: "gray",
                      fontWeight: 600,
                    }}
                  >
                    Admin <br /> QR Code
                  </span>
                </>
              )}
            </label>

            {/* QR Update/Delete Buttons */}
            <div style={{ display: "flex", justifyContent: "center" }} className="my-3">
              {/* <button
                onClick={() => { setConfirmAction('updateQR'); setPopupMessage('Are you sure you want to update the QR code?'); setPopup(true); }}
                className="add-button f3 w-100 fs-xs-16 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19 sec"
                disabled={updating || !check}
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "8px",
                  minHeight: 48,
                  backgroundColor: !check ? '#c3937b' : PRIMARY_COLOR,
                  border: !check ? "1px solid #c3937b" : `1px solid ${PRIMARY_COLOR}`
                }}
              >
                {updating ? <>
                  <span
                    className="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                    style={{ color: "black" }}
                  ></span>
                </> : "Update"}
              </button> */}
              <SubmitButton
                onClick={() => { setConfirmAction('updateQR'); setPopupMessage('Are you sure you want to update the QR code?'); setPopup(true); }}
                disabled={updating || !check}
                isFormValid={updating || !check}
                loading={updating}
                title="Update"
              />
            </div>
            <div className="my-2">
              {/* <button
                onClick={() => { setConfirmAction('deleteQR'); setPopupMessage('Are you sure you want to delete the QR code?'); setPopup(true); }}
                className="add-button f3 w-100 fs-xs-16 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19 sec"
                disabled={deleting}
              >
                {deleting ? <>
                  <span
                    className="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                    style={{ color: "black" }}
                  ></span>
                </> : "Delete"}
              </button> */}
              <SubmitButton
                onClick={() => { setConfirmAction('deleteQR'); setPopupMessage('Are you sure you want to delete the QR code?'); setPopup(true); }}
                disabled={deleting}
                title="Delete"
              />
            </div>
          </div>

          {/* ===== QR 2 Section ===== */}
          <div className="mt-5 textChanges QRCode_container col-md-5">
            <input
              id="qrCodeUpload2"
              ref={fileInputRef2}
              type="file"
              accept="image/*"
              style={{ display: "none" }}
              className="placholdercolorchanges2"
              onChange={handleFileChange2}
            />

            <label style={{ position: "relative" }} htmlFor="qrCodeUpload2" className="mt-2 QRcode sec">
              {qrImages2 ? (
                <img
                  src={
                    qrImages2 instanceof File
                      ? URL.createObjectURL(qrImages2)
                      : qrImages2
                  }
                  alt="QR Preview"
                  style={{
                    width: "150px",
                    height: "150px",
                    borderRadius: "10px",
                    objectFit: "contain",
                  }}
                />
              ) : (
                <>
                  <img
                    src={QR}
                    alt="QR Placeholder"
                    style={{
                      width: "150px",
                      height: "150px",
                      borderRadius: "10px",
                      objectFit: "contain",
                      border: "1.8px dashed #a7a3a3"
                    }}
                  />
                  <span
                    style={{
                      position: "absolute",
                      right: 40,
                      top: 50,
                      color: "gray",
                      fontWeight: 600,
                    }}
                  >
                    Admin <br /> QR Code
                  </span>
                </>
              )}
            </label>

            {/* QR Update/Delete Buttons */}
            <div style={{ display: "flex", justifyContent: "center" }} className="my-3">
              {/* <button
                onClick={() => { setConfirmAction('updateQR2'); setPopupMessage('Are you sure you want to update the QR code?'); setPopup(true); }}
                className="add-button f3 w-100 fs-xs-16 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19 sec"
                disabled={updating3 || !check3}
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "8px",
                  minHeight: 48,
                  backgroundColor: !check3 ? '#c3937b' : PRIMARY_COLOR,
                  border: !check3 ? "1px solid #c3937b" : `1px solid ${PRIMARY_COLOR}`,
                }}
              >
                {updating3 ? <>
                  <span
                    className="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                    style={{ color: "black" }}
                  ></span>
                </> : "Update"}
              </button> */}
              <SubmitButton
                onClick={() => { setConfirmAction('updateQR2'); setPopupMessage('Are you sure you want to update the QR code?'); setPopup(true); }}
                disabled={updating3 || !check3}
                isFormValid={updating3 || !check3}
                title="Update"
              />
            </div>
            <div className="my-2">
              {/* <button
                onClick={() => { setConfirmAction('deleteQR2'); setPopupMessage('Are you sure you want to delete the QR code?'); setPopup(true); }}
                className="add-button w-100 f3  fs-xs-16 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19 sec"
                disabled={deleting3}
              >
                {deleting3 ? <>
                  <span
                    className="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                    style={{ color: "black" }}
                  ></span>
                </> : "Delete"}
              </button> */}
              <SubmitButton
                onClick={() => { setConfirmAction('deleteQR2'); setPopupMessage('Are you sure you want to delete the QR code?'); setPopup(true); }}
                disabled={deleting3}
                title="Delete"

              />
            </div>
          </div>

          {/* ===== UPI Section ===== */}
          <div className="my-3 col-md-5">
            <label className="form-label f3 fs-md-14 fs-lg-16 m-0 primary1">Admin UPI ID</label>
            <div className="d-flex ac-js w-100">
              <div style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }} className="textChanges copy-input">
                <input
                  type="text"
                  name="copyUpi"
                  value={formData.copyUpi}
                  onChange={(e) => { handleChange(e); setCheck2(true); }}
                  className="newupi placholdercolorchanges2"
                  placeholder="Enter Admin UPI ID"
                />
              </div>
            </div>

            {/* UPI Update/Delete Buttons */}
            <div style={{ display: "flex", justifyContent: "center" }} className="my-3">
              {/* <button
                onClick={() => { setConfirmAction('updateUPI'); setPopupMessage('Are you sure you want to update the UPI ID?'); setPopup(true); }}
                className="add-button w-100 f3 fs-xs-16 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19 sec"
                disabled={updating2 || !check2}
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "8px",
                  minHeight: 48,
                  backgroundColor: !check2 ? '#c3937b' : PRIMARY_COLOR,
                  border: !check2 ? "1px solid #c3937b" : `1px solid ${PRIMARY_COLOR}`
                }}
              >
                {updating2 ? <>
                  <span
                    className="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                    style={{ color: "black" }}
                  ></span>
                </> : "Update"}
              </button> */}
              <SubmitButton
                onClick={() => { setConfirmAction('updateUPI'); setPopupMessage('Are you sure you want to update the UPI ID?'); setPopup(true); }}
                disabled={updating2 || !check2}
                isFormValid={updating2 || !check2}
                title="Update"

              />
            </div>
            <div style={{ display: "flex", justifyContent: "center" }} className="my-2">
              {/* <button
                onClick={() => { setConfirmAction('deleteUPI'); setPopupMessage('Are you sure you want to delete the UPI ID?'); setPopup(true); }}
                className="add-button w-100 f3 fs-xs-16 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19 sec"
                disabled={deleting2}
              >
                {deleting2 ? <>
                  <span
                    className="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                    style={{ color: "black" }}
                  ></span>
                </> : "Delete"}
              </button> */}
              <SubmitButton
                onClick={() => { setConfirmAction('deleteUPI'); setPopupMessage('Are you sure you want to delete the UPI ID?'); setPopup(true); }}
                disabled={deleting2}
                title="Delete"
              />
            </div>
          </div>
        </div>
      </CustomScroll>
      {/* Loader */}
      {loading && <Loader />}

      {/* Confirmation Popup */}
      {/* {popup && (
        <div className="img-popup-design">
          <div className="img-popup">
            <p className="f3 fs-xs-14 fs-sm-15 fs-md-15 fs-lg-15 fs-xl-17 fs-xxl-19 primary">
              {popupMessage}
            </p>
            <div style={{ paddingTop: 20 }} className="d-flex ac-jb px-2 f3 fs-xs-14 fs-sm-15 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19">
              <button onClick={() => { setPopup(false); setConfirmAction(''); setPopupMessage(''); }} className="no-btn w-40">
                No
              </button>
              <button
                onClick={handleConfirm}
                className="yes-btn f3 w-40 f3 fs-xs-14 fs-sm-15 fs-sm-11 fs-md-13 fs-lg-15 fs-xl-17 fs-xxl-19"
              >
                {loading1 ? <>
                  <span
                    className="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                    style={{ color: "black" }}
                  ></span>
                </> : 'Yes'}
              </button>
            </div>
          </div>
        </div>
      )} */}

      <CommonPopup
        isOpen={popup}
        message={popupMessage}
        onClose={() => { setPopup(false); setConfirmAction(''); setPopupMessage(''); }}
        onConfirm={handleConfirm}
        loading={loading1}
        confirmText="Yes"
      />

      {/* Cropper Modal */}
      {cropperModal && (
        <div className="img-popup-design" style={{ zIndex: 9999 }}>
          <div className="img-popup" style={{ maxWidth: "90%", width: "800px", maxHeight: "90vh" }}>
            <h4 className="f3 primary mb-3">Crop QR Code</h4>
            <p className="text-muted mb-3">Adjust the crop area to select the QR code, then click "Crop & Save"</p>

            <div className="cropper-container" style={{
              width: "100%",
              height: "400px",
              marginBottom: "20px",
              backgroundColor: "#f5f5f5"
            }}>
              <img
                ref={cropperImageRef}
                src={cropperImage}
                alt="Crop preview"
                style={{
                  maxWidth: "100%",
                  maxHeight: "100%",
                  display: "block"
                }}
                crossOrigin="anonymous"
              />
            </div>

            <div className="cropper-controls d-flex justify-content-center gap-3 mt-3">
              <button
                onClick={handleCancelCrop}
                className="no-btn f3"
                style={{ minWidth: "120px", padding: "10px 20px" }}
              >
                Cancel
              </button>
              <button
                onClick={handleCrop}
                className="yes-btn f3"
                style={{ minWidth: "120px", padding: "10px 20px" }}
              >
                Crop & Save
              </button>
            </div>

            <div className="mt-3 text-center">
              <small className="text-muted">
                Drag to move, scroll to zoom. Adjust the square crop area for optimal QR code scanning.
              </small>
            </div>
          </div>
        </div>
      )}

    </div>
  );
};

export default AdminRecharge;